import { CHECK_TABLE_POPUP_IS_OPEND } from "../constants/actionTypes";

export const setCheckPopStatus = (status) => {
  return { type: CHECK_TABLE_POPUP_IS_OPEND, status: status };
};